const CHANNEL_NAME = 'mcp-app:auth';
const LOGOUT_MESSAGE = 'logout';

function createChannel(): BroadcastChannel | null {
    if (typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') return null;

    return new BroadcastChannel(CHANNEL_NAME);
}

export function broadcastLogout(): void {
    const channel = createChannel();
    if (!channel) return;
    channel.postMessage(LOGOUT_MESSAGE);
    channel.close();
}

export function onLogoutBroadcast(listener: () => void): () => void {
    const channel = createChannel();
    if (!channel) return () => { };
    const handler = (event: MessageEvent) => {
        if (event.data === LOGOUT_MESSAGE) listener();           
    };
    channel.addEventListener('message', handler);
    return () => {
        channel.removeEventListener('message', handler);
        channel.close();
    };
}